import { PortalComponent } from 'components/common/PortalComponent';
import { Outlet, useOutletContext } from 'react-router';
import { FC } from 'react';
import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';

export const ConsultantModalOutlet: FC = () => {
  const modalNavigationContext = useOutletContext<ModalNavigationContext>();

  return (
    <PortalComponent>
      <Outlet context={modalNavigationContext} />
    </PortalComponent>
  );
};
